// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/sonderdruckfeder-mit-loetbarer-oberflaeche/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSonderdruckfederMitLoetbarerOberflaecheDE: PageEntry = {
  id: "example.produkte-sonderdruckfeder-mit-loetbarer-oberflaeche",
  locale: "de",
  slug: "produkte/sonderdruckfeder-mit-loetbarer-oberflaeche",
  seo: {
    title: "Sonderdruckfeder mit lötbarer Oberfläche | Dietz GmbH",
    description: "Weiterverarbeitung in einer SMT-Bestückung und Einsatz der Platinen in unterschiedlichsten Haushaltsgeräten mit Touchfeldern. Neben der hohen Genauigkeitsanforderung muss die autom",
  },
  type: "post",
  h1: "Sonderdruckfeder mit lötbarer Oberfläche",
  intro: "Weiterverarbeitung in einer SMT-Bestückung und Einsatz der Platinen in unterschiedlichsten Haushaltsgeräten mit Touchfeldern. Neben der hohen Genauigkeitsanforderung muss die automatische Zuführbarkeit sichergestellt werden.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_sonderdruckfeder.jpg", alt: "Sonderdruckfeder mit lötbarer Oberfläche", width: 1400, height: 1120 }
  ],
};
